import angular from 'angular';

export const QueryStringBuilderFactoryModule = angular.module('acme.common.factory.QueryStringBuilder', [])
.factory('QueryStringBuilderFactory', [function() {


  function QueryStringBuilder(config) {
    if (config) {
      this.init(config);
    }
  }

  QueryStringBuilder.prototype = {

    constructor: QueryStringBuilder,

    q: [],
    query: '',
    properties: {},

    init: function(config) {
      var r = true;

      this.reset();

      if (config.hasOwnProperty('props')) {
        this.properties = config.props;

        if (config.hasOwnProperty('fields')) {
          if (config.fields.hasOwnProperty('requires')) {
            r = this.addRequired(config.fields.requires);
          }

          if (config.fields.hasOwnProperty('optional')) {
            this.addOptional(config.fields.optional);
          }
        }

        if (r) {
          if (this.build()) {
            r = this.query;
          }
        }
      } else {
        r = false;
      }

      return r;
    },

    reset: function() {
      this.q = [];
      this.query = '';
      this.properties = {};
    },

    build: function() {
      var r = false;
      if (this.q.length > 0) {
        this.query = '?' + this.q.join('&');
        r = true;
      }
      return r;
    },

    addRequired: function(list) {
      var i, ii,
          r = true;

      for (i=0,ii=list.length;i<ii;i++) {
        if (this.properties.hasOwnProperty(list[i]) && this.properties[list[i]]) {
          this.q.push(list[i] + '=' + encodeURIComponent(this.properties[list[i]]));
        }else{
          r = false;
          this.q = [];
          break;
        }
      }
      return r;
    },

    addOptional: function(list) {
      var i, ii;
      for (i=0,ii=list.length;i<ii;i++) {

        if (this.properties.hasOwnProperty(list[i]) && this.properties[list[i]]) {
          this.q.push(list[i] + '=' + encodeURIComponent(this.properties[list[i]]));
        }
      }
    }

  };

  return QueryStringBuilder;

}]).name;